const imageAspectRatios = ['1:1', '16:9', '4:3', '5:4', '3:4'];

export default imageAspectRatios;
